import { render, staticRenderFns } from "./repairThree.vue?vue&type=template&id=8556cd4c&scoped=true&"
import script from "./repairThree.vue?vue&type=script&lang=js&"
export * from "./repairThree.vue?vue&type=script&lang=js&"
import style0 from "./repairThree.vue?vue&type=style&index=0&id=8556cd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556cd4c",
  null
  
)

export default component.exports